/**
 * TemplateMessageField: seletor único + editor de variáveis juntos
 * (2026-09-14). É o que as telas de automação usam: escolher o template e, se
 * ele tiver variáveis que a tela consegue preencher, dizer o que entra em cada
 * uma. Trocar de template zera os valores.
 */
import React, { useMemo } from 'react';
import TemplatePicker from './TemplatePicker';
import TemplateParamsEditor from './TemplateParamsEditor';
import {
  analyzeTemplate, templateUsability, findTemplate, uniqueApproved,
  emptyTemplateValues, CAPS_FULL,
} from '../../utils/templateParams';

const TemplateMessageField = ({
  templates = [],
  loading = false,
  templateName = '',
  templateLanguage = '',
  onTemplateChange,
  values,
  onValuesChange,
  capabilities = CAPS_FULL,
  colors,
  placeholder,
  noneLabel,
  emptyHint,
  mode = 'bulk',
  contactKey,
  contactName,
  previewContact,
  disabled = false,
}) => {
  const selected = useMemo(
    () => findTemplate(uniqueApproved(templates), templateName, templateLanguage),
    [templates, templateName, templateLanguage],
  );
  const analysis = useMemo(() => (selected ? analyzeTemplate(selected) : null), [selected]);
  const usable = analysis ? templateUsability(analysis, capabilities).usable : false;

  const handlePick = (template) => {
    const mudou = !template || template.name !== templateName
      || (templateLanguage && template.language !== templateLanguage);
    onTemplateChange?.(template);
    if (mudou) onValuesChange?.(emptyTemplateValues());
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <TemplatePicker
        templates={templates}
        loading={loading}
        value={templateName}
        language={templateLanguage}
        onChange={handlePick}
        capabilities={capabilities}
        colors={colors}
        placeholder={placeholder}
        noneLabel={noneLabel}
        emptyHint={emptyHint}
        disabled={disabled}
      />
      {selected && usable && analysis.requiresParams && onValuesChange && (
        <TemplateParamsEditor
          key={`${selected.name}|${selected.language}`}
          template={selected}
          value={values}
          onChange={onValuesChange}
          capabilities={capabilities}
          colors={colors}
          mode={mode}
          contactKey={contactKey}
          contactName={contactName}
          previewContact={previewContact}
        />
      )}
    </div>
  );
};

export default TemplateMessageField;
